export default (state = {}, action) => {
  switch( action.type ) {
    case 'IMAGE_CLICK':
      return {
        ...state,
        currentImage: action.currentImage,
        images: action.images,
        isGalleryOpen: true
      };
    case 'GALLERY_CLOSE':
      return {
        ...state,
        isGalleryOpen: false
      };
    case 'PREVIOUS_CLICK':
      return {
        ...state,
        currentImage: state.currentImage - 1
      }
    case 'NEXT_CLICK':
      return {
        ...state,
        currentImage: state.currentImage + 1
      }
    case 'THUMBNAIL_CLICK':
      return {
        ...state,
        currentImage: action.payload
      }
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/gallery.js